module.exports = __webpack_public_path__ + "img/Dantam Fashion 17.0b6969cc.jpg";